<div class="d-inline-block">
  <button
    mat-flat-button
    class="new-sorting-btn ms-3"
    [matMenuTriggerFor]="filterMenu"
    [ngClass]="{'active': isFilterApplied}"
    (click)="!isFilterApplied && openDefault(); isFilterApplied && prevData()"
  >
    <div class="d-flex align-items-center">
      <div class="" (click)="isFilterApplied && removeFilter($event)">
        <img src="assets/images/plus-circle.svg" alt="">
      </div>
      <span class="ms-2">{{ resolvedLabel }} <span *ngIf="isFilterApplied">| </span></span>
      <h6 class="m-0 ms-1" *ngIf="isFilterApplied">
        {{ selectedView }}%
      </h6>
    </div>
  </button>

  <div>
    <mat-menu class="new-mat-menu mt-1 dateFilter" #filterMenu="matMenu" xPosition="after">
      <div class="p-3" (click)="stopPropagation($event)" style="box-sizing: border-box; width: 260px;">
        <p class="mb-2" style="font-size: 13px; font-weight: 700; color: #1e293b; font-family: 'Gilroy', sans-serif;">Filter by {{ resolvedLabel }}</p>

        <app-select
          size="compact"
          [options]="equalityOptions"
          [(ngModel)]="selectedEquality"
          placeholder="Select"
          class="w-100 mb-2"
        ></app-select>

        <div class="d-flex align-items-center mt-2 mb-3">
          <div class="me-2 d-flex align-items-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.5 8.33331L16.6667 12.5L12.5 16.6666" stroke="#0386FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M3.33301 3.33331V9.16665C3.33301 10.0507 3.6842 10.8985 4.30932 11.5237C4.93444 12.1488 5.78229 12.5 6.66634 12.5H16.6663" stroke="#0386FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <div class="flex-grow-1">
            <input
              class="search-input-from-list ps-2 w-100"
              placeholder="0.00"
              [(ngModel)]="filterValue"
              (input)="validateNumberInput($event)"
            />
          </div>
        </div>

        <app-primary-button
          label="APPLY"
          size="medium"
          [fullWidth]="true"
          [disabled]="!filterValue"
          (btnClick)="applyFilter()"
        ></app-primary-button>
      </div>
    </mat-menu>
  </div>
</div>
